import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { SITE } from "../config/site";

export default function LegalPage({ content, path }) {
  return (
    <>
      <Seo title={content.title} path={path} description={content.intro.slice(0, 155)} />
      <section className="pt-40 pb-16 lg:pt-48">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <Reveal>
            <span className="eyebrow mb-7">{content.eyebrow}</span>
            <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter">
              {content.title}
            </h1>
            <p className="mt-6 text-base md:text-lg text-zinc-400 leading-relaxed">{content.intro}</p>
            <p className="mt-4 font-mono text-xs text-zinc-600">
              Last updated: {SITE.lastUpdated}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 lg:pb-28" data-testid="legal-body">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <div className="flex flex-col gap-12">
            {content.sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="glass rounded-2xl p-7 sm:p-9">
                  <h2 className="font-display text-xl md:text-2xl font-bold tracking-tight text-ink-50 mb-5 flex items-center gap-4">
                    <span className="font-mono text-xs text-gold-400/60">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {s.heading}
                  </h2>
                  {"body" in s && s.body && (
                    <div className="flex flex-col gap-4">
                      {s.body.map((p, j) => (
                        <p key={j} className="text-sm md:text-[15px] text-zinc-400 leading-relaxed">
                          {p}
                        </p>
                      ))}
                    </div>
                  )}
                  {"bullets" in s && s.bullets && (
                    <ul className="flex flex-col gap-3">
                      {s.bullets.map((b, j) => (
                        <li key={j} className="flex gap-3 text-sm md:text-[15px] text-zinc-400 leading-relaxed">
                          <span className="mt-1.5 h-1.5 w-1.5 rotate-45 bg-gold-400/70 shrink-0" />
                          {b}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}